module.exports = "/images/02c9da1d40.png";